import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid ${COLORS.lightGrey};
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const PageInfo = styled.div`
  color: ${COLORS.lightGrey};
  font-size: 0.875rem;
`;

export const PageButtonsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const PageButton = styled.button`
  padding: 0.5rem 0.75rem;
  background: ${(props) => (props.active ? COLORS.violet : COLORS.white)};
  color: ${(props) => (props.active ? COLORS.white : COLORS.black)};
  border: 1px solid
    ${(props) => (props.active ? COLORS.violet : COLORS.lightGrey)};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.active ? COLORS.darkViolet : COLORS.lightestViolet};
    border-color: ${(props) =>
      props.active ? COLORS.darkViolet : COLORS.lightGrey};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PageEllipsis = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  color: ${COLORS.lightGrey};
  font-size: 0.875rem;
`;
